export const sortFields = [
	'state',
	'sourceOrganization',
	'targetOrganization',
	'recipes',
	'createdAt',
	'updatedAt',
	'updatedBy',
] as const;
